import * as config from './config';

export const ROOT_PATH = '/';
export const PROJECT_PATH = config.routePath.pyxisPortalPath;
export const LOGIN_PATH = `${PROJECT_PATH}/login`;
export const ANNOUNCEMENT_PATH = `${PROJECT_PATH}/announcement`;
export const PYXIS_PATH = `${PROJECT_PATH}/pyxis-desktop`;
